import property from 'lodash/property';
import * as type from "./types";
import { Policy } from "../../model";
import axios from "axios";
import {_fetchAddressesFailed} from "../addresses/service";
import {ANZSIC_SGPPACK_LIST, ANZSIC_HKGPACK_LIST} from "../policy/types";
import { _sendLog } from '../../utils/utility';

export const _storePolicy = (policy : Policy ) => {
    _sendLog(['SME-React - Policy Service - _storePolicy: ', JSON.stringify(policy, null, 3)], 'info');
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.POLICY_STORE,
            data: policy
        })
    };
}

export const _fetchPolicyFailed = () => {
    return {
        type: type.POLICY_FETCH_FAILED
    };
}

export function _setAgentCode(agentCode: string){
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.SET_AGENT_CODE,
            agentCode: agentCode
        });
    }
}

export function _ratePolicy() {
    // let tempPolicy: Policy = {
    //     productType: 'BIZ',
    //     country: 'SGP',
    //     agentCode: '01001354',
    //     campaign: '',
    //     policySME: {
    //         buildingSI: 1500000,
    //         contentsSI: 50000,
    //         situationTurnoverCode: '1',
    //         numberOfEmployees: 1,
    //         annualWages: 1500000,
    //         officePack: true,
    //         shopPack: false,
    //         occupationCode: 785401,
    //         occupationDesc: 'Office',
    //
    //         insuredPerson: 'Mike Pater',
    //
    //         locationAddress1: '123 ADMIRALTY ROAD WEST',
    //         locationDistrict: '',
    //         locationDistrictDesc: '',
    //         locationPostCode: '759954',
    //         locationAccumulationRegister: '',
    //         locationUnitNo: '',
    //         locationFloorNo: '',
    //         locationBuildingName: '',
    //         locationBuildingStreetNo: '',
    //         locationCountry: 'SGP',
    //
    //         totalGrossAmount: 0,
    //         totalDiscount: 0,
    //         totalDueAmount: 0,
    //         subsidyAmount: 0,
    //         riskNumber: 0,
    //         policyPremium: {
    //             premium: 0,
    //             annualPremium: 0,
    //             levy: 0,
    //             ecLevy: 0,
    //             totalPremium: 0,
    //             discount: 0,
    //             discountRate: 0,
    //             insuredCommissionDiscount: 0,
    //             insuredCommissionDiscountRate: 0
    //         }
    //     }
    // }

    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            let policy : any = _getPolicy(getState());
            let hasInsuredPerson = true;

            if (!policy.policySME.insuredPerson || policy.policySME.insuredPerson === '') {
                // fill in dummy value to make policy rate working.
                hasInsuredPerson = false;
                policy.policySME.insuredPerson = 'dummy';
                policy.policySME.locationAddress1 = 'dummy';
                policy.policySME.locationPostCode = '759954';
                policy.policySME.applicant.applicantAddress1 = 'dummy';
                policy.policySME.applicant.applicantPostCode = '759954';
           }

            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_POLICY_RATE_URL, JSON.stringify(policy), { headers: {'Content-Type': 'application/json'} })
                .then(resp => {
                    let newPolicy = resp.data;
                    // reset value
                    if (!hasInsuredPerson || policy.policySME.insuredPerson === 'dummy') {
                        newPolicy.policySME.insuredPerson = '';
                        newPolicy.policySME.locationAddress1 = '';
                        newPolicy.policySME.applicantPostCode = '';
                        newPolicy.policySME.applicant = {
                            clientType: 'C',
                            sameAsInsuredAddress: true,
                            directMarketing: false
                        }
                        newPolicy.policySME.inceptionDate = '';
                        // set expiry date
                        newPolicy.policySME.expiryDate = '';
                    }

                    dispatch({
                        type: type.POLICY_STORE,
                        data: newPolicy
                    });
                    resolve(resp.data);
                })
                .catch(error => {
                    console.error(error);
                    _sendLog(['SME-React - Policy Service - _ratePolicy: ', error]);
                    dispatch(_fetchAddressesFailed())
                    reject(error);
                });
        })
    }
}

export function _savePendingTransaction(policy: Policy) {
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_UPDATE_TO_PENDING_URL, JSON.stringify(policy), {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    dispatch({
                        type: type.POLICY_STORE,
                        data: resp.data.policy
                    });
                    resolve(resp.data);
                })
                .catch(error => {
                    console.log(error);
                    _sendLog(['SME-React - Policy Service - _savePendingTransaction: ', error])
                    reject(error);
                });
        })
    };
}

export function _logPaymentLifecycle(policy: Policy) {
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_LOG_PAYMENT_LIFECYCLE, JSON.stringify(policy), {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    console.log('_logPaymentLifecycle - success return');
                    resolve('success');
                })
                .catch(error => {
                    console.error(error);
                    _sendLog(['SME-React - Policy Service - _logPaymentLifecycle: ', error]);
                    reject(new Error(error));
                });
        })
    };
}

export function _issueAndReceiptPolicy(policy: Policy) {
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_ISSUE_AND_RECEIPT_POLICY, JSON.stringify(policy), {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    dispatch({
                        type: type.POLICY_STORE,
                        data: resp.data.policy
                    });
                    resolve();
                })
                .catch(error => {
                    console.error(error);
                    _sendLog(['SME-React - Policy Service - _issueAndReceiptPolicy: ', error]);
                    reject(error);
                });
        })
    };
}

export const _searchUen = async (uenNo: string) => {
    return new Promise<any>((resolve, reject) => {
        // Search UEN business name in the background and update
        if (!!uenNo) {
            // Flag for checking if there is a UEN issued by ACRA. If false, return UEN issued by Others instead
            let isACRA = false;
            
            let configACRA =  {};
            if (process.env.REACT_APP_ENV  !== 'dev') {
                configACRA = {
                    params: {
                        handlerEnabled: false
                    }
                }
            }

            // Search for ACRA-issued UEN
            const uenSearchURLACRA = process.env.REACT_APP_UEN_SEARCH_URL_ACRA + uenNo?.trim();
            const searchResultACRA = axios.get(uenSearchURLACRA, configACRA).then(resp => {
                if (resp?.data?.result?.records) {
                    if (resp?.data?.result?.records.length > 0) {
                        console.log("[policy/service] searchUenACRA success result");
                        resolve(resp?.data?.result?.records.filter((record: any) => {
                            if(record.uen.indexOf(uenNo) != -1){
                                isACRA = true;
                                return true;
                            }
                            return false;
                        }));
                    }
                } else {
                    console.error("[policy/service] searchUenACRA failed no result");
                    resolve(undefined);
                }
            }).catch(error => {
                reject(error);
            });

            let configOthers =  {};
            if (process.env.REACT_APP_ENV  !== 'dev') {
                configOthers = {
                    params: {
                        handlerEnabled: false
                    }
                }
            }

            // Search for UEN issued by other agencies
            const uenSearchURLOthers = process.env.REACT_APP_UEN_SEARCH_URL_OTHERS + uenNo?.trim();
            const searchResultOthers = axios.get(uenSearchURLOthers, configOthers).then(resp => {
                if (resp?.data?.result?.records) {
                    if (resp?.data?.result?.records.length > 0) {
                        console.log("[policy/service] searchUenOthers success result");
                        resolve(resp?.data?.result?.records.filter((record: any) => {
                            if(record.uen.indexOf(uenNo) != -1){
                                return true;
                            }
                            return false;
                        }));
                    }
                } else {
                    console.error("[policy/service] searchUenOthers failed no result");
                    resolve(undefined);
                }
            }).catch(error => {
                reject(error);
            });

            if (isACRA) {
                return searchResultACRA;
            }
            return searchResultOthers;
        } else {
            reject([]);
        }
    })
}


export const _searchUenName = async (uenNo: string) => {
    return new Promise<string>((resolve, reject) => {
        if (!!uenNo) {
            let config =  {};
            if (process.env.REACT_APP_ENV  !== 'dev') {
                config = {
                    params: {
                        handlerEnabled: false
                    }
                }
            }
            const uenSearchURL = process.env.REACT_APP_UEN_SEARCH_URL + uenNo?.trim();
            axios.get(uenSearchURL, config).then(resp => {
                const entityName = resp?.data?.result?.records[0]?.entity_name
                    .replace(uenNo, "").trim();
                if (entityName) {
                    console.log(`[policy/service] searchUen success result = ${entityName}`);
                    resolve(entityName);
                } else {
                    let error = "[policy/service] searchUen failed no result";
                    console.error(error);
                    resolve(error);
                }
            }).catch(error => {
                reject(error);
            });
        } else {
            reject("UEN is undefined");
        }

    });
}

const isPackegeQuote = (id: any, country: string): boolean => {
  let packageKeys = [];
  if(country === 'SGP'){
    packageKeys = ANZSIC_SGPPACK_LIST.map(keys =>  keys.substring(4, keys.length) );
  } else {
    packageKeys = ANZSIC_HKGPACK_LIST.map(keys =>  keys.substring(4, keys.length) );
  }

  return packageKeys.indexOf(id) > -1;
}

export const _getOccupationsForIndustry = async (industryId: string, country: string) => {
  const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
  return axios.get(server + '/b2c-server/anzsics/divisions/' + industryId + '/sub-divisions/' + country)
    .then(resp => {
        console.log('_getOccupationsForIndustry: ', resp.data);
      return resp.data.filter((item: any) => {
        return isPackegeQuote(item.id, country);
      });
    })
    .catch(error => {
      console.error('error @ _getOccupationsForIndustry', error);
      _sendLog(['SME-React - Policy Service - _getOccupationsForIndustry: ', error]);
      return [];
    });
}


export const _findQuote = (quoteId: string) => {
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.get(server + process.env.REACT_APP_FIND_QUOTE + quoteId)
                .then(resp => {
                    if (resp.data.errorMessage) {
                        console.error('Encountered error: ' + resp.data.errorMessage);
                        _sendLog(['SME-React - Policy Service - _findQuote - Encountered error: ', resp.data.errorMessage])
                        reject(resp.data.errorMessage);
                    } else {
                        let policyObj = JSON.parse(resp.data.policy);
                        policyObj.savedForLaterToken = quoteId;

                        console.log(JSON.stringify(policyObj));
                        dispatch({
                            type: type.POLICY_STORE,
                            data: policyObj
                        });
                        resolve(resp.data);
                    }
                })
                .catch(error => {
                    console.error(error);
                    _sendLog(['SME-React - Policy Service - _findQuote: ', error]);
                    reject(error);
                });
        });
    };
};


export const _saveQuote = (data: any) => {
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_SAVE_QUOTE,
                data,{headers: {'Content-Type': 'application/json'}} )
                .then(resp => {
                    if (resp.data.success){
                        let policyObj = {
                          savedForLaterToken: resp.data.token
                        };
                        dispatch({
                            type: type.POLICY_STORE,
                            data: policyObj
                        });
                        resolve();
                    }
                })
                .catch(error => {
                    console.error(error);
                    _sendLog(['SME-React - Policy Service - _saveQuote: ', error]);
                    reject(error);
                });
        });
    };
};

export const _getPolicy = property ( 'pl' );
export const _getSaveForLaterToken = property('pl.savedForLaterToken')
